module.exports = __webpack_public_path__ + "static/923778358.f7ac84da.jpg";